import { Component, inject, Input } from '@angular/core';

import { DownloadPdfAnalyticsService } from '~features/pdfAnalytics/download-pdf-analytics.service';
import { TrackDownloadDirective } from '~features/user-behavior-analytics/directives';
import { PosthogService } from '~shared/services/posthog.service';

@Component({
  selector: 'app-button-download-pdf',
  imports: [TrackDownloadDirective],
  templateUrl: './button-download-pdf.component.html',
})
export class ButtonDownloadPdfComponent {
  pdfAnalycitsService = inject(DownloadPdfAnalyticsService);
  @Input() pdf;
  @Input() buttonClasses = '';
  postHogService = inject(PosthogService);
  updatePdfCounter(pdfURL) {
    this.pdfAnalycitsService.addPDFCounter(pdfURL);

    this.postHogService.trackPDFDownload();
  }
}
